import {Injectable} from "@angular/core";
import {WITHOUT_COMMISSION} from "../constants/payment.constant";
import {PaymentTransactionResponse} from "../interface/paymentTransactionResponse";

@Injectable({
  providedIn: 'root',
})
export class PaymentTransactionUtil {
  getCommission(isCommissionActive: boolean, paymentTransactionResponse: PaymentTransactionResponse): number {
    return isCommissionActive
      ? (paymentTransactionResponse.commission ?? paymentTransactionResponse.userCardCommission)
      : WITHOUT_COMMISSION;
  }
}
